export default "__VITE_ASSET__Fatbj0$n__"